import { httpsCallable } from 'firebase/functions';
import { doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { auth, chatFunctions, db } from '../../../firebase';

const X_API_KEY = process.env.REACT_APP_X_API_KEY || "";

export interface HandlebarsTemplatesResult {
  subject: string;
  body: string;
  story: string;
}

export const generateHandlebarsTemplates = async (fields: any[]): Promise<HandlebarsTemplatesResult> => {
  const generateFn = httpsCallable<any, HandlebarsTemplatesResult>(chatFunctions, 'generateHandlebarsTemplates');
  const result = await generateFn({ fields });
  return result.data;
};

export interface SaveTemplatesParams {
  templateId: string;
  companyId: string;
  fields: any[];
}

export const saveGeneratedHandlebarsTemplates = async ({
  templateId,
  companyId,
  fields
}: SaveTemplatesParams): Promise<HandlebarsTemplatesResult> => {
  if (!templateId) {
    throw new Error('Template ID is required.');
  }

  if (!companyId) {
    throw new Error('Company ID is required.');
  }

  const templates = await generateHandlebarsTemplates(fields);

  await updateDoc(doc(db, 'flexFormTemplates', templateId), {
    notificationSubjectLine: templates.subject,
    notificationBody: templates.body,
    updatedAt: serverTimestamp(),
  });

  const user = auth.currentUser;
  if (!user) {
    throw new Error('User not authenticated');
  }

  const idToken = await user.getIdToken();
  const response = await fetch(`https://europe-west3-twodata-dev.cloudfunctions.net/tenantapi/flexFormStoryTemplates/${templateId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': X_API_KEY,
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({
      handlebarsTemplate: templates.story,
      templateId,
      companyId,
      active: !!templates.story?.trim(),
    }),
  });

  if (!response.ok) {
    throw new Error(`Story template API error: ${response.status}`);
  }

  return templates;
};